(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["push-bundles"] && !Shopify.designMode) return;
  try {
    class BundleVariantSelects extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange.bind(this));
    }

    handleChange(event) {
      if (event.target.tagName.toLowerCase() !== 'select') return;
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.renderBundleInfo();
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]:not([id^="Product-Item-Data-"])').textContent);
      return this.variantData;
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = this.querySelector('form');
      if (!productForm) return;
      const addButton = productForm.querySelector('[type="submit"]');
      const addButtonText = productForm.querySelector('[type="submit"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    removeErrorMessage() {
      const productForm = this.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    setUnavailable() {
      const form = this.querySelector('form');
      const addButton = form.querySelector('[type="submit"]');
      const addButtonText = form.querySelector('[type="submit"] > span');
      const price = form.querySelector('[role="status"]');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }

    updateVariantInput() {
      const form = this.querySelector('form');
      const input = form.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    renderBundleInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=fetch-bundle`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const priceDestination = this.querySelector(`#price-${this.dataset.identifier}`);
          const priceSource = html.querySelector('[id^="price-"]');
          if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
          if (priceDestination) priceDestination.classList.remove('visibility-hidden');

          const bundleComponentImages = this.querySelectorAll('[data-component-image]');
          if (bundleComponentImages.length) {
            bundleComponentImages.forEach((image) => {
              const newImage = html.querySelector(`[data-component-image="${image.dataset.componentImage}"]`);
              if (newImage && newImage.querySelector('img')) {
                const newImageImg = newImage.querySelector('img');
                const imageImg = image.querySelector('img');
                for (const attr of newImageImg.attributes) {
                  imageImg.setAttribute(attr.name, attr.value);
                }
              }
            });
          }

          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
  }

  customElements.define('bundle-variant-selects', BundleVariantSelects);
  } catch(e) { console.error(e); }
})();

})();
